import React, { Component } from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';

import Routes from '../Routes';

class Routecontainer extends React.Component{
    render(){
        return(
            <main style={{ marginTop:'1rem'}}>
                <Routes />
            </main>
        )
    }
}
export default withRouter(Routecontainer)